import { useStaticQuery, graphql } from 'gatsby';

const Query = () => {
  const data = useStaticQuery(graphql`
    query {
      contentfulFormFields {
        firstName
        lastName
        email
        centerName
        titleLabel
        titleList
        enrollmentRangeLabel
        enrollmentRangeList
        centerEnrolmentLabel
        centerEnrolmentList
        phoneNumber
      }
      getToKnow: contentfulFlexBlock(id: {eq:"4b9a8dda-aff5-508c-bcea-e08d957336cc"}) {
        ...FlexBlock
      }
      featureLinks: contentfulFlexBlock(id: {eq:"deaf6f4c-7287-5569-bb9a-c9299628f49f"}) {
        ...FlexBlock
      }
      getInTouch: contentfulFlexBlock(id: {eq:"af7a77cc-373b-5a6b-bbbb-b0c6b4771ea9"}) {
        ...FlexBlock
      }
      metaImage: contentfulAsset(title: {eq: "Industry Snapshot Report 2024"}) {
        ...Image
      }
    }
  `)
  return data
}

export default Query
